// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5I1yB","right":"styles_right__1hyAb"};